// extracted by mini-css-extract-plugin
export var hideEditor = "_s5-2";
export var infoIcon = "_s5-3";
export var label = "_s5-1";
export var labelContainer = "_s5-0";
export var readonlyText = "_s5-4";